module.exports = __webpack_public_path__ + "media/images/mv_btn_pc-ac46708e5f20292683997624ca5dc88a.png";